export const userViewsCookieBanner = pathname => ({
  type: '[View] Cookie Banner',
  data: {
    path: pathname,
  },
});

export const userClicksCookieBannerCTA = (buttonCopy, pathname) => ({
  type: `[Click] Cookie Banner - ${buttonCopy}`,
  data: {
    path: pathname,
  },
});

export const userClicksCookieBannerLink = (linkText, pathname) => ({
  type: `[Click] Cookie Banner - ${linkText}`,
  data: {
    path: pathname,
  },
});
